import { useState } from "react";
import { Modal, Button } from "antd";
import CountrySupport from "../../components/Settings/Personal Settings/CountrySupport";
import { countryData } from "../../utils/data/jsonData";
import CountryContacts from "./CountryContacts";
import { useTenant } from "../../store/context/tenant-context";

const CountrySupportModal = ({ isModalOpen, handleOkay, handleCancel }) => {
  const [country, setCountry] = useState({});
  const [isSupportOpen, setIsSupportOpen] = useState(false);

  const handleClick = (country) => {
    setCountry(country);
  };

  const handleOk = () => {
    setIsSupportOpen(false);
    setCountry({});
  };

  const handleSupportModal = () => {
    setIsSupportOpen(true);
    handleOkay();
  };
const tenant = useTenant();
  return (
    <>
      <Modal
        title={<p className="text-center">Support</p>}
        open={isModalOpen}
        onOk={handleOkay}
        onCancel={handleCancel}
        footer={[
          <div className="w-full" key="footer-row">
            <div className="flex justify-between items-center h-full gap-3 mb-5">
              <Button
                key="close"
                onClick={handleCancel}
                className={`h-full w-full px-6 py-2 border-[${tenant.theme.colorPrimary}] shadow-none text-center text-base`}
                style={{ color: tenant.theme.colorPrimary }}
              >
                Cancel
              </Button>
              <Button
                key="continue"
                type="primary"
                disabled={!country.name}
                onClick={handleSupportModal}
                className="h-full w-full px-6 py-2 shadow-none text-center text-base"
              >
                Continue
              </Button>
            </div>
          </div>,
        ]}
        width="80vw"
      >
        <>
          <div className="mb-5">
            <p className="text-lg font-semibold mb-1">Where are you from?</p>
            <p className="text-[#929497] text-left">
              Select your country to get personalized assistance
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {countryData.map((item) => (
              <CountrySupport
                key={item.id}
                country={item}
                isSelected={item.name === country.name}
                onCardClick={handleClick}
              />
            ))}
          </div>
        </>
      </Modal>

      <CountryContacts
        isOpen={isSupportOpen}
        onOpen={handleOk}
        onCancel={handleOk}
        selectedCountry={country}
      />
    </>
  );
};

export default CountrySupportModal;
